<div class="mb-5 gap-3 flex" [ngStyle]="{ 'float': 'right' }">
   @if(!expiredCredentialsCandidateView && credentials.length > 0){
        <p-button pTooltip="Approve all" tooltipPosition="top" (click)="approveAllCredentialsAndEducation($event, config.data.reviewer)" [rounded]="true" label="approve all"></p-button> 
   }
   <p-button pTooltip="More Details" tooltipPosition="top" (click)="requestInformation($event)" [rounded]="true" label="request more information"></p-button>

    <p-button [pTooltip]="'Archive'" tooltipPosition="top" (click)="showDeleteReviewerConfirmation($event,config.data.reviewer)" [rounded]="true" [text]="true" icon="true">
        <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
    </p-button>
</div>
<div class="projects-data" [ngStyle]="{ 'clear': 'both' }">
    <div class="grid grid-nogutter">
        <div class="col-12 p-0">
            <div class="data-table">
                <p-table styleClass="p-datatable-sm p-datatable-sm--normal"
                [value]="credentials" 
                [showCurrentPageReport]="true" 
                [tableStyle]="{ 'min-width': '50rem' }"
                    autoLayout="true"
                    [scrollable]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            
                            <th>S.No</th>
                            <th>Degree / description</th>
                            <th>ID / Member no.</th>
                            <th>Institution / certification</th>
                            <th>Type</th>
                            <th>Issue date</th>
                            <th>Expiration date</th>
                            <th>Auto renewal</th>
                            @if(userObject.firm.isBackgroundCheckRequired){
                                <th>Background status</th>
                            }
                            <th>Status</th>
                            @if (helperService.checkResponsive()) {
                                <th alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                            } @else {
                                <th>
                                    <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                            }
                            <ng-template #frozenHeader>
                            Action
                            </ng-template>
                            @if(getEligibleCredentialsCount() > 0) {
                                <th>
                                    <p-button 
                                        pTooltip="Approve / Deny" 
                                        (onClick)="manualBulkCredsEducationApproval($event, true)" 
                                        tooltipPosition="top" 
                                        [rounded]="true" 
                                        [disabled]="getSelectedCredentialsCount() === 0"
                                        label="Approve/Deny">
                                    </p-button> 
                                </th>
                            }
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-credential let-rowIndex="rowIndex">
                        <tr>
                            
                            <td>{{rowIndex + 1}}</td>
                            <td>{{credential.description || '-'}}</td>
                            <td>{{credential.code || '-'}}</td>
                            <td>{{credential.school || '-'}}</td>
                            <td>{{credential.type}}</td>
                            <td>{{credential.issuedAt ? (credential.issuedAt | date : 'MMM d, y h:mm a' ):'-'}}</td>
                            <td>{{credential.expiresAt ? (credential.expiresAt | date : 'MMM d, y h:mm a' ):'-'}}</td>
                            <td>{{credential.autoRenewal ? 'Yes' : 'No'}}</td>
                            @if(userObject.firm.isBackgroundCheckRequired){
                                <td>{{credential.bgStatus ? credential.bgStatus : 'N/A'}}</td>
                            }
                            <td>{{credential.status}}</td>
                            @if (helperService.checkResponsive()) {
                                <td alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                            } @else {
                                <td>
                                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                            }
                            <ng-template #frozenData>
                                <div class="wrap-actions">
                                    @if(credential.type === 'EDUCATION' && config.data.reviewer.permissions.education && config.data.reviewer.tenants.length && config.data.reviewer.tenants[0].firm && config.data.reviewer.tenants[0].firm.isNscEnabled){
                                        <div>
                                            <p-button (onClick)="backgroundCheck('nsc',credential )" [rounded]="true" [text]="true" icon="true">
                                                <img  src="assets/images/nsc-icon.png" class="acc-nsc-check-icon" alt="Image" height="90" />
                                            </p-button>
                                        </div>
                                    }
                                    @if(checkToShowNscDetails(credential)){
                                        <span 
                                            [pTooltip]="getTooltipText(credential)" 
                                            tooltipPosition="top" 
                                            [escape]="false"
                                            icon="true"
                                            class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined cursor-pointer text-primary-600">
                                        </span>
                                    }
                                    <div>
                                    <!-- @if(userObject.firm.isBackgroundCheckRequired && credential.type !== 'CRIMINAL' ){
                                        <p-button (onClick)="openBackgroundcheckModal($event, credential)" [rounded]="true" [text]="true" icon="true">
                                            <img  src="assets/images/acc-bg-check-icon.png" class="acc-nsc-check-icon" alt="Image" height="90" />
                                        </p-button>
                                    } -->
                                    </div>
                                    @if(credential.downloadURL){
                                        <p-button (onClick)="downloadDocument(credential.downloadURL)" tooltipPosition="top"  pTooltip="Download Audit Document"  [rounded]="true" [text]="true" icon="true">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined"></span>
                                        </p-button>
                                    }
                                    @if((
                                    (!isPwcEnabled && credential.bgStatus !== constants.secureBackgroundStatus.manualApproved) ||
                                    (isPwcEnabled && credential.status === 'Expired')
                                    ) && (credential.type === constants.bgCheckTypes.EDUCATION || credential.type
                                    === constants.bgCheckTypes.CREDENTIALS )){
                                    <p-button (onClick)="manualApproveCredential($event,credential)" tooltipPosition="top" pTooltip="Manual Approve"
                                        [rounded]="true" [text]="true" icon="true">
                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-check-box-outlined"></span>
                                    </p-button>
                                    }
                                    @if(credential.certificate){
                                        <p-button (onClick)="downloadDocument(credential.certificateDownloadURL)" tooltipPosition="top"  pTooltip="Download Credential Document" [rounded]="true" [text]="true" icon="true">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-download-outlined"></span>
                                        </p-button>
                                    }
                                        
                                </div>
                            </ng-template>
                            @if(getEligibleCredentialsCount() > 0){
                                @if(isCredentialEligibleForSelection(credential)) {
                                    <td style="text-align: center;">
                                        <p-checkbox 
                                            [binary]="true" 
                                            (onChange)="onRowSelectionChange(credential, $event)"
                                            [ariaLabel]="'Select credential ' + (rowIndex + 1)">
                                        </p-checkbox>
                                    </td>
                                }
                                @else {
                                    <td></td>
                                }
                            }
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>